/* eslint-disable @typescript-eslint/no-explicit-any */
import * as d3 from 'd3';

export type AnyD3Selection = d3.Selection<any, any, any, any>;
export type GroupSelection = d3.Selection<SVGGElement, any, any, any>;

export type SvgElementNameToType = {
  rect: SVGRectElement;
  text: SVGTextElement;
  g: SVGGElement;
  any: SVGElement;
  path: SVGPathElement;
  circle: SVGCircleElement;
  line: SVGLineElement;
};

export class SelectorSpec<K extends keyof SvgElementNameToType> {
  elementType: SvgElementNameToType[K] = null as any;
  constructor(public elementName: K, public selector: string) {}
}

export class ClassNameSelectorSpec<K extends keyof SvgElementNameToType> extends SelectorSpec<K> {
  constructor(public elementName: K, public className: string) {
    super(elementName, `${elementName}.${className}`);
  }
}

export function selectAndJoin<
  Spec extends ClassNameSelectorSpec<keyof SvgElementNameToType>,
  Datum
>(
  selection: d3.Selection<any, any, any, any>,
  selectorSpec: Spec,
  data: Datum[],
): d3.Selection<Spec['elementType'], Datum, any, any> {
  const res = selection
    .selectAll(selectorSpec.selector)
    .data(data)
    .join(selectorSpec.elementName)
    .classed(selectorSpec.className, true);
  return res as any;
}

export function ensureSingleElem<Spec extends ClassNameSelectorSpec<keyof SvgElementNameToType>>(
  selection: d3.Selection<any, any, any, any>,
  selectorSpec: Spec,
): d3.Selection<SvgElementNameToType[Spec['elementName']], any, any, any> {
  if (!selectorSpec.className) {
    throw new Error(`Need className for selectAndJoin`);
  }
  const {selector} = selectorSpec;
  const sel = selection.select(selector);
  const size = sel.size();
  if (size > 1) {
    throw new Error(`Expecting single element with selector "${selector}"`);
  } else if (size === 1) {
    return sel as any;
  } else {
    return selection.append(selectorSpec.elementName).classed(selectorSpec.className, true) as any;
  }
}
